// src/index.js
import "bootstrap/dist/css/bootstrap.min.css";
import React from "react";
import { createRoot } from "react-dom/client";
import App from "./App";
import { initEntra } from "./entraAuth";

const container = document.getElementById("root");
const root = createRoot(container);

// Handle a return from the Entra redirect before the first render.
// initEntra never rejects; failures surface on the sign-in page.
initEntra().then(() => root.render(<App />));
